// extracted by mini-css-extract-plugin
module.exports = {"shoppingCartContainer":"VenuesShoppingCart_shoppingCartContainer__3aj7u","shoppingCartList":"VenuesShoppingCart_shoppingCartList__EtOml"};